import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import FooterNew from '../components/Footer'
import { useTranslation } from 'react-i18next'

const Datenschutzrichtlinien = () => {
  const { t } = useTranslation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const privacyPolicyContent = [
    {
      title: 'Information We Collect',
      points: [
        'Personal Information: Name, email, address, and other contact information.',
        'Usage Data: Information about your interaction with our platform.',
        'Cookies: Data stored on your device for improved user experience.',
      ],
    },
    {
      title: 'How We Use Information',
      points: [
        'Provide, maintain, and improve our services.',
        'Personalize your experience and communicate with you.',
        'Analyze usage data to enhance our platform.',
      ],
    },
    {
      title: 'Detailed Privacy Practices',
      points: [
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac tellus eget est malesuada interdum. Suspendisse et justo ac dui fermentum varius eu non odio. Nulla facilisi. Mauris at nulla quam. Curabitur in tortor mauris.',
        'Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Suspendisse auctor non justo vel laoreet.',
        'Nunc malesuada eget eros vel dignissim. Aliquam erat volutpat. Vivamus dapibus urna ac sem efficitur, ac lacinia lacus bibendum.',
      ],
    },
    {
      title: 'Information Sharing',
      points: [
        'We do not sell, trade, or otherwise transfer your information to third parties.',
        'Service Providers: Share data with trusted third-party service providers.',
        'Legal Compliance: Disclose information when required by law.',
      ],
    },
    // Add more sections as needed
  ]

  return (
    <>
      <Container className='tns-margin-bottom'>
        <div className='text-center mt-5'>
          <h1 className='pricing-header-1'>{t('privacy_policy_page.title')}</h1>
        </div>

        {privacyPolicyContent.map((section, index) => (
          <div key={index} className='mt-5 text-center'>
            <h2 className='mb-3'>{section.title}</h2>
            <p className='text-right'>
              {section.points.map((point, i) => (
                <span key={i}>
                  {point}
                  <br />
                </span>
              ))}
            </p>
          </div>
        ))}
      </Container>
      <FooterNew />
    </>
  )
}

export default Datenschutzrichtlinien
